export default {
    getRequestError(state){
      return state.request_error;
    },
    getVendors(state) {
      return state.vendors;
    },
    getShowrooms(state) {
      return state.showrooms;
    },
    getConnections(state) {
      return state.connections;
    },
  };